var map = {
	"./all-all.png": 899,
	"./angel-female.png": 461,
	"./angel-male.png": 900,
	"./demon-female.png": 901,
	"./demon-male.png": 462,
	"./dragon-female.png": 902,
	"./dragon-male.png": 463,
	"./dragonborn-female.png": 903,
	"./dragonborn-male.png": 904,
	"./elf-female.png": 464,
	"./elf-male.png": 905,
	"./fairy-female.png": 465,
	"./fairy-male.png": 906,
	"./human-female.png": 907,
	"./human-male.png": 466,
	"./orc-female.png": 908,
	"./orc-male.png": 467
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 373;